module.exports = __webpack_public_path__ + "static/media/imgBiz.3d59675b.svg";